import React from 'react'
import classNames from 'classnames'
import { HiChevronRight } from 'react-icons/hi'
import { FaAngleDoubleRight } from 'react-icons/fa'
import { HiChevronDoubleRight } from 'react-icons/hi2'

const Las = (props) => {
    const { currentPage, pageCount, pagerClass, onNext } = props

    const disabled = currentPage === pageCount || pageCount === 0

    const onNextClick = (e) => {
        e.preventDefault()
        if (disabled) {
            return
        }
        onNext(e)
    }

    const pagerNextClass = classNames(
        pagerClass.default,
        'pagination-pager-next',
        disabled ? pagerClass.disabled : pagerClass.inactive
    )

    return (
        <span className={pagerNextClass} onClick={onNextClick}>
            <HiChevronDoubleRight size={20}/>
        </span>
    )
}

export default Las
